import { Button, Card, Col, Container, Row, } from "react-bootstrap";

import React from 'react'

const stylePaddingMarginReset = {
  padding: '0',
  mergin: '0',
}


const ProductCard = ({ title, description, image, link, button }) => {

  return (
    <Card className='rounded-0  border-0' style={{ color: 'black', minHeight: '100%' }}>
      <Card.Img className='rounded-0 card-img-center' variant="top" src={image} />
      <Card.Body className="text-center">
        <Card.Title>{title}</Card.Title>
        <Card.Text><span dangerouslySetInnerHTML={{ __html: description }} /></Card.Text>
        <Button variant="link" className="float-right text-sm text-secondary" href={link}>{button}</Button>
      </Card.Body>
    </Card>
  );
};



const ProductList = ({ products, title, description, button = 'dettagli' }) => {
  const numCols = Math.min(products.length, 6);
  return (
    <div style={{}}>
      <Row>
        <Col md={12} className="text-center"><h2>{title}</h2></Col>
      </Row>
      <Row>
        <Col style={{ padding: '5vh' }} md={12} className="text-center">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </Col>
      </Row>
      <Row className="justify-content-center">
        {products.map((product, index) => (
          <Col style={stylePaddingMarginReset} md={12 / numCols} key={index}>
            <ProductCard title={product.title} description={product.description} image={product.image} link={product.link} button={button} />
          </Col>
        ))}
      </Row>
    </div>

  );
};



export const Home = () => {
  const wineyard = [
    {
      title: "Vigneto Sialic",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/sialic.jpg",
      link: "/vigneti/sialic",
    },
    {
      title: "Vigneto Bram",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/bram.jpg",
      link: "/vigneti/bram",
    },
    {
      title: "Vigneto Brichet",
      description: "<small class='text-secondary'>Bagnolo Piemonte</small>",
      image: "/images/vineyards/brichet.jpg",
      link: "/vigneti/brichet",
    },
  ];

  const wines = [
    {
      title: "Sialic",
      description: "Sauvignon",
      image: "/images/wines/i sialic.png",
      link: "/vini/sialic",
    },
    {
      title: "Bram",
      description: "Pinot nero",
      image: "/images/wines/i bram.png",
      link: "/vini/bram",
    },
    {
      title: "Classici",
      description: "Da tradizione",
      image: "/images/wines/i classici.png",
      link: "/vini/brichet",
    },
  ];


  return (<>
    <Container>
      <Row style={{ paddingTop: '30vh', padding: '10vh' }}>
        <blockquote className="blockquote text-center">
          <h2>Benvenuti nell'Azienda Vitivinicola Agù</h2>
          <p className="mb-0">Una storia familiare che risale agli anni '80, fondata su una passione per il vino, l'innovazione e la costante ricerca della massima qualità. Pionieri nella nostra zona, abbiamo introdotto l'imbottigliamento e la ricerca dell'appellativo DOC. Oggi, continuiamo questa tradizione di innovazione, aprendoci a vitigni internazionali e abbracciando la viticultura eroica, con un vigneto di Sauvignon completamente terrazzato e un nuovo vigneto di Pinot, situato accanto alla storica vigna del "Brichet." <br></br>Benvenuti nel mondo dell'Azienda Vitivinicola Agù, dove la tradizione si fonde con l'innovazione, il passato si intreccia con il futuro, e i vitigni internazionali si mescolano con la tradizione vinicola locale per creare vini espressivi.</p>
        </blockquote>
        <Button variant="link" className="float-right text-sm text-secondary" href={"/storia"}>Leggi la nostra storia</Button>
      </Row>
    </Container>
    <div style={{ backgroundColor: 'black', color: 'white', paddingTop: '5vh' }}>
      <ProductList
        products={wineyard}
        title="I Nostri Vigneti: Il Cuore dell'Azienda"
        description="Nei nostri vigneti si cela il cuore pulsante dell'Azienda. Qui abbracciamo con convinzione il detto che <blockquote class='blockquote'><span className=' font-italic'>	&quot;il vino si fa in vigna, non in cantina.&quot;</span></blockquote>"
        button="Entra in Vigna" />
    </div>
    <div style={{ backgroundColor: 'black', color: 'white', paddingTop: '5vh' }}>
      <ProductList
        products={wines}
        title='I Nostri Vini: Storie in Bottiglia di Passato, Presente e Futuro'
        description=" Ogni bottiglia racconta una storia di passione, dedizione e qualità, dove il gusto del passato si mescola con l'entusiasmo per il futuro in ogni sorso."
        button="Scopri le Annate" />
    </div>
  </>)
}
